import {Container, Graphics, Sprite, Text} from "pixi.js";
import {Vector} from "../i.js"; // ../vector.js
import {RES} from "../i.js"; // ../dump.js
import {UIUtils} from "../i.js"; // ../ui/utils.js
import {Tab} from "../i.js"; // ./tab.js

class Message {
	constructor(tab, text) {
		this.tab = tab;

		this.display = new Container();
		this._icon = new Sprite(RES["images/icons/profile.svg"].texture);
		this._icon.tint = tab.colorHighlight;
		this._background = new Graphics();
		this._textDisplay = new Text(
			text,
			UIUtils.getFont(tab.colorHighlight, {wordWrap: true})
		);
		this.display.addChild(this._icon, this._background, this._textDisplay);
	}

	// Returns the height of the rendered message
	update(tabWidth, position, size) {
		let margin = this.tab.unicenter.requestMarginWidth(1);

		this.display.position.copyFrom(position);

		this._icon.scale.set(0.1 * tabWidth / this._icon.texture.width);

		this._textDisplay.style.fontSize = this.tab.unicenter.requestFontSize("SMALL");
		this._textDisplay.style.wordWrapWidth = 2 / 3 * tabWidth;

		let boxSize = new Vector(
			this._textDisplay.width + 2 * margin,
			this._textDisplay.height + 2 * margin
		).round();
		let boxPosition = new Vector(this._icon.width + margin, 0).round();
		if (boxSize.y < this._icon.height) boxPosition.y = Math.round(
			(this._icon.height - boxSize.y) / 2
		);

		this._textDisplay.position.copyFrom(Vector.sum(
			boxPosition, new Vector(margin, margin)
		));
		this._background
			.clear()
			.lineStyle(
				this.tab.unicenter.requestStroke(this.tab.colorHighlight, "NARROW")
			)
			.drawRect(
				boxPosition.x, boxPosition.y,
				boxSize.x, boxSize.y
			);

		return Math.max(boxSize.y, Math.round(this._icon.height));
	}
}



export class Chat extends Tab {
	static MESSAGES = [
		"wazzup! \ud83d\ude43\ud83d\ude80 lemme give you a quick rundown on this thing",
		"you can turn around with your mouse, move with (W), and fire by holding down the"
			+ " left mouse button. there are a bunch more controls too, but you can"
			+ " figure those out by hovering over stuff and reading tooltips",
		"when you destroy stuff it gives you items! you can dock to a station to refine"
			+ " those items into resources, and then use the resources to buy upgrades."
			+ " a lot of steps, i know",
		"to find cool places, check out the gps tab! it's the z-shaped icon on the right"
			+ " \u27a1\ufe0f",
		"sorry for the infodump! it's like a lazy god who is making this universe isn't"
			+ " done with it yet, and i gotta investigate that. in the meantime you go"
			+ " have fun!"
	];

	// Create a new chat
	// Each unicenter should create exactly one chat. unicenter is a
	// reference to the unicenter.
	constructor(unicenter) {
		super(
			unicenter,
			null,
			Tab.LOCATIONS.RIGHT,
			"images/icons/chat.svg",
			60,
			"Chat"
		);

		this._messages = Chat.MESSAGES.map(text => {
			let message = new Message(this, text);
			this.display.addChild(message.display);
			return message;
		});
	}

	// Update the chat
	// Call this every tick. visible is a boolean that is true if the display is
	// visible this tick. size is a vector in pixels representing the desired
	// size of the display.
	update(visible, size) {
		super.update(visible, size);
	}

	// Refresh the display, redrawing everything from scratch
	// This method only needs to be called when something actually changed, but
	// it's okay to call it every tick.
	_refreshDisplay() {
		let size = this.display.size;


		let nextChatPosition = new Vector();
		for (let message of this._messages) {
			let messageHeight = message.update(size.x, nextChatPosition);
			nextChatPosition.y += messageHeight + this.unicenter.requestMarginWidth(2);
		}
	}
}
